import storage from "../../storage"

export function TokenGuard(to, from, next) {
    const accessToken = storage.local.getAccessToken()

    if (!accessToken)
        return next('/login')

    return next()
}
